import useRecentSearchCard, {
  SearchProductList
} from '@/hooks/useRecentSearchCard'
import useBootstrapData from '@/hooks/useBootstrapData'
import useMostRecentFutureBooking from '@/hooks/useMostRecentFutureBooking'
import useAbandonedSelectionsManager from './useAbandonedSelectionManager'

function useTripActivityData(productType: SearchProductList) {
  const {
    webstats: { clientGUID },
    appName,
    appVersion,
    signInStatus: { signedIn }
  } = useBootstrapData()

  const { mostRecentFutureBooking } = useMostRecentFutureBooking()

  const abandonedSelection = useAbandonedSelectionsManager(
    productType,
    { clientGUID, appName, appVersion, signedIn },
    !!mostRecentFutureBooking
  )

  const data = useRecentSearchCard(
    clientGUID,
    { appName, appVersion },
    productType,
    signedIn
  )
  const atMostFiveRecentSearchCards = data.length > 5 ? data.slice(0, 5) : data

  if (mostRecentFutureBooking) {
    return {
      abandonedSelection: null,
      atMostFiveRecentSearchCards
    }
  }

  if (abandonedSelection) {
    return {
      abandonedSelection,
      atMostFiveRecentSearchCards
    }
  }

  return {
    abandonedSelection: null,
    atMostFiveRecentSearchCards
  }
}

export default useTripActivityData
